

































import {
    ComparisonProduct,
    Component,
    ComponentStyle,
    ComponentStyleDefinition,
    InjectComponent,
    ProductPropertyGroup,
    Prop,
    Vue,
    VueComponent
} from "@zoovu/runner-browser-api";

@Component({})
export default class ShownProductsView extends Vue {

    @Prop()
    shownProducts: ComparisonProduct[];

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("ProductPriceView")
    productPriceView: VueComponent;

    @Prop()
    propertyGroups: ReadonlyArray<ProductPropertyGroup>;

    @InjectComponent("PropertyGroupView")
    propertyGroupView: VueComponent;

    @InjectComponent("ProductClickoutLinkView")
    productClickoutLinkView: VueComponent;

    shownProductRemoved(product) {
        this.shownProducts.splice(this.shownProducts.lastIndexOf(product), 1);
        this.$emit("shown-product-removed", product);
    }

}
